import { render } from "./SystemNotificationAlert.vue?vue&type=template&id=6035d906"
import script from "./SystemNotificationAlert.vue?vue&type=script&lang=js"
export * from "./SystemNotificationAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__